import React from 'react';
import { useRightColumnContext } from 'Context/RightColumnContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import ScenarioDetailsDrawer
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/ScenarioDetailsDrawer';
import ScenarioDetailsRightColumn
  from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ScenarioDetailsPicker/ScenarioDetailsRightColumn';

const ScenarioDetailsPicker = () => {
  const { showRightColumnCollection } = useRightColumnContext();
  const isMobile = useMobileLayout();

  if (!showRightColumnCollection) {
    return null;
  }

  if (isMobile) {
    return <ScenarioDetailsDrawer open={showRightColumnCollection} />;
  }

  return (
    <ScenarioDetailsRightColumn />
  );
};

export default ScenarioDetailsPicker;
